module.exports = __webpack_public_path__ + "static/media/ds-podium_02.08900df9.png";